// ** Core JWT Import
import useJwt from '@src/@core/auth/jwt/useJwt'

const serviceBaseUrl = process.env.REACT_APP_API_BASE_URL
const { jwt } = useJwt({
  loginEndpoint: `${serviceBaseUrl}/auth/login`,
  registerEndpoint: `${serviceBaseUrl}/auth/login`,
  refreshEndpoint: `${serviceBaseUrl}/auth/refresh`,
  logoutEndpoint: `${serviceBaseUrl}/auth/logout`,

  // loginEndpoint: '/jwt/login',
  // registerEndpoint: '/jwt/register',
  // refreshEndpoint: '/jwt/refresh-token',
  // logoutEndpoint: '/jwt/logout',

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken'
})

export default jwt
